import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TiktokOpenService } from 'src/app/shared/services';
import { tiktokStoreProviders } from 'src/app/shared/config/store-config';
import { TiktokOrdersComponent } from '../../../shared/components/tiktok-orders/tiktok-orders.component';

@Component({
    selector: 'app-tiktok-order-page',
    templateUrl: './tiktok-order-page.component.html',
    styleUrls: ['./tiktok-order-page.component.scss'],
    providers: [...tiktokStoreProviders('tiktok-genlogic'), TiktokOpenService],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TiktokOrdersComponent],
})
export class TiktokOrderPageComponent {
    constructor() {}
}
